// 获取环境变量中配置的URL
export const BASE_URL = process.env.REACT_APP_URL



// fetch('example.com').then((data) => {
//     // do somethings
//     // 展示弹窗
// }).catch((error) => {
//     // do error
// })